export const LAYOUT_CONFIG = {
    ADMIN_NAME: "Quechoisirreclamations.org",
    COMPANY_DETAILS: {
        SHOW_POINTS: true
    },
    USER_DETAILS: {
        SHOW_POINTS: false
    },
    USE_GESTAL: true,
    LOCALE: "fr"
}